import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import generalEN from './locales/en/general.json';
import locationEN from './locales/en/location-edit.json';
import dogDetailsEN from './locales/en/dog-details.json';
import dogDocumentsEN from './locales/en/dog-documents.json';
import dogPhotoEN from './locales/en/dog-photo.json';
import eventEditEN from './locales/en/event-edit.json';
import classEditEN from './locales/en/class-edit.json';
import vetVisitEditEN from './locales/en/vet-visit-edit.json';
import exerciseEditEN from './locales/en/exercise-edit.json';
import answerEditEN from './locales/en/answer-edit.json';
import quickTrainingEN from "./locales/en/quick-training.json";
import deploymentEditEN from './locales/en/deployment-edit.json';
import profileEditEN from './locales/en/profile-edit.json';
import billingEditEN from './locales/en/billing-edit.json';
import trackingDeploymentEN from './locales/en/tracking-deployment';
import trackingLeadEN from './locales/en/tracking-lead';
import trackingFollowEN from './locales/en/tracking-follow';

import generalFR from './locales/fr/general.json';
import dogDetailsFR from './locales/fr/dog-details.json';
import dogDocumentsFR from './locales/fr/dog-documents.json';
import dogPhotoFR from './locales/fr/dog-photo.json';

i18n
  .use(initReactI18next)
  .init({
    lng: "en",
    resources: {
      en: {
        general: generalEN,
        location: locationEN,
        dogDetails: dogDetailsEN,
        dogDocuments: dogDocumentsEN,
        dogPhoto: dogPhotoEN,
        eventEdit: eventEditEN,
        classEdit: classEditEN,
        vetVisitEdit: vetVisitEditEN,
        exerciseEdit: exerciseEditEN,
        answerEdit: answerEditEN,
        quickTraining: quickTrainingEN,
        deploymentEdit: deploymentEditEN,
        profileEdit: profileEditEN,
        billingEdit: billingEditEN,
        trackingDeployment: trackingDeploymentEN,
        trackingLead: trackingLeadEN,
        trackingFollow: trackingFollowEN,
      },
      fr: {
        general: generalFR,
        dogDetails: dogDetailsFR,
        dogDocuments: dogDocumentsFR,
        dogPhoto: dogPhotoFR,
      }
    },
    interpolation: {
      escapeValue: false
    },
    debug: false
  });

  export default i18n;